import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import LocalizedStrings from "react-localization";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    requestPermissionInfo: "Permission Status",
    adminEmail: "Admin Email",
    permission: "Permission",
    showInfoButton: "Show Info",
    remarkHeader: "Remark",
    approvalAllow: "Approved",
    approvalDeny: "Denied",
    approvalPending: "Pending",
    none: "None",
    noDataTitle: "No data found",
  },
  ja: {
    requestPermissionInfo: "許可ステータス",
    adminEmail: "管理者メール",
    permission: "許可",
    showInfoButton: "情報を表示",
    remarkHeader: "理由",
    approvalPending: "保留中",
    approvalAllow: "承認する",
    approvalDeny: "拒否",
    none: "なし",
    noDataTitle: "データーがありません",
  },
  es: {
    requestPermissionInfo: "Estado de Permiso",
    adminEmail: "Correo Electrónico del Administrador",
    permission: "Permiso",
    showInfoButton: "Mostrar Info",
    remarkHeader: "Observación",
    approvalAllow: "Aprobado",
    approvalDeny: "Denegado",
    approvalPending: "Pendiente",
    none: "Ninguno",
    noDataTitle: "No se encontraron datos",
  },
});

class DetailsButton extends Component {
  constructor(props) {
    super(props);

    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.permissionFormat = this.permissionFormat.bind(this);
    this.remarkFormat = this.remarkFormat.bind(this);
    // this.adminNameFormat = this.adminNameFormat.bind(this);

    const shareAccessToken = this.props.shareAccessToken;

    this.state = {
      shareAccessToken: shareAccessToken,
      permissionList: [],
      noDataText: "loading...",
      showPopup: false,
      loading: false,
      userLocksShareToken: [],
      adminName: "",
    };
  }

  componentWillMount() {
    //! FOR LANGUAGE
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  handlePopupOpen() {
    this.setState({
      showPopup: true,
    });

    const shareAccessToken = this.state.shareAccessToken;
    let adminPermissionList = [];
    let userMultiData = {};
    fire
      .database()
      .ref("retractableSharingRegistry")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((snapshotChild) => {
          snapshotChild.forEach((snapshotChildren) => {
            const snapChildrenVal = snapshotChildren.val();
            if (snapChildrenVal.shareAccessToken === shareAccessToken) {
              for (const i in snapChildrenVal.multiSharingAdmins) {
                // fire
                //   .database()
                //   .ref("registeredIndustrialUsersOnPlatform")
                //   .child(auth.currentUser.uid)
                //   .child("name")
                //   .once("value")
                //   .then(userName => {
                //     userMultiData = {
                //       adminEmail:
                //         snapChildrenVal.multiSharingAdmins[i].adminEmail,
                //       adminUid: snapChildrenVal.multiSharingAdmins[i].adminUid,
                //       hasAllowed:
                //         snapChildrenVal.multiSharingAdmins[i].hasAllowed,
                //       remark: snapChildrenVal.multiSharingAdmins[i].remark,
                //       adminName: userName.val()
                //     };
                //     adminPermissionList.push(
                //       snapChildrenVal.multiSharingAdmins[i]
                //     );
                //     adminPermissionList.push(userName.val());
                //   });
                adminPermissionList.push(snapChildrenVal.multiSharingAdmins[i]);
              }
            }
          });
        });
      })
      .then(() => {
        this.setState({
          permissionList: adminPermissionList,
        });
        customLog(adminPermissionList);
      });

    if (adminPermissionList.length <= 0) {
      this.setState({
        noDataText: localizationStrings.noDataTitle,
      });
    }
  }

  handlePopupClose() {
    this.setState({ showPopup: false });
  }

  permissionFormat(permssion, row) {
    if (row !== undefined) {
      let remark = row.remark;

      if (permssion === true) {
        return localizationStrings.approvalAllow;
      } else if (permssion === false) {
        if (remark !== null && remark !== undefined && remark !== "") {
          return localizationStrings.approvalDeny;
        } else {
          return localizationStrings.approvalPending;
        }
      }
    }
  }

  remarkFormat(remark) {
    if (remark !== null && remark !== undefined && remark !== "") {
      return remark;
    } else {
      return localizationStrings.none;
    }
  }

  // adminNameFormat(adminUid) {

  //   fire
  //     .database()
  //     .ref("registeredIndustrialUsersOnPlatform")
  //     .child(adminUid)
  //     .once("value")
  //     .then(async usersDetail => {
  //       await this.setState({
  //         adminName: usersDetail.val().name
  //       });
  //     })
  // }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        <Modal show={this.state.showPopup} onHide={this.handlePopupClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.requestPermissionInfo}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <BootstrapTable
              // pagination
              bordered={false}
              data={this.state.permissionList}
              options={{
                sizePerPage: 10,
                hideSizePerPage: true,
                noDataText: this.state.noDataText,
              }}
            >
              <TableHeaderColumn
                isKey={true}
                dataField="adminEmail"
                columnTitle={columnHover}
                // dataFormat={this.adminNameFormat}
              >
                {localizationStrings.adminEmail}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="hasAllowed"
                dataFormat={this.permissionFormat}
                columnTitle={this.permissionFormat}
              >
                {localizationStrings.permission}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="remark"
                dataFormat={this.remarkFormat}
                columnTitle={this.remarkFormat}
              >
                {localizationStrings.remarkHeader}
              </TableHeaderColumn>
            </BootstrapTable>
          </Modal.Body>
        </Modal>

        <Button
          onClick={this.handlePopupOpen}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {localizationStrings.showInfoButton}
        </Button>
      </div>
    );
  }
}

export default DetailsButton;
